import { render } from "./simcards.vue?vue&type=template&id=c6aed63a"
import script from "./simcards.vue?vue&type=script&lang=js"
export * from "./simcards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__